import { customAxios } from '../../common/customAxios';
import { myOwnTractorsApiUrl } from '../queries/getMyOwnTractors';

interface deleteMyOwnTractorParams {
  ownTractorId: string;
}

export const deleteMyOwnTractor = ({ ownTractorId }: deleteMyOwnTractorParams): Promise<void> => {
  return customAxios.delete(`${myOwnTractorsApiUrl}/${ownTractorId}`);
};
